import { render, staticRenderFns } from "./SaleTaxGroupActionDelete.vue?vue&type=template&id=7ff49d6a&"
import script from "./SaleTaxGroupActionDelete.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports